import styled from "styled-components/macro";

export const StyledMainFAQ = styled.div``;

export const StyledNav = styled.nav`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: #f5f2e4;

  img {
    padding: 24px;
    width: 80px;
    opacity: 0.5;
  }

  ul {
    list-style-type: none;

    li {
      display: inline-block;
      font-family: "Inter";
      font-weight: 500;
      padding: 24px 5px 24px 24px;

      &:last-child {
        padding-right: 36px;
      }

      a {
        color: #2b2315;
        opacity: 0.5;
      }
    }
  }
`;
